<template>
  <div :style="divStyle" id="addressPage">
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>

    <Tabs>
      <TabPane label="列表结构" name="list" icon="ios-list">
        <Row style="padding-bottom: 10px;margin-top: 10px;">
          <Col span="4" style="padding-right: 10px;">
            <Button type="primary" long @click="onClickSearch">检索</Button>
          </Col>
        </Row>
        <Table
          ref="selectionTable"
          :max-height="height"
          :data="showData"
          :columns="showColumns"
          stripe
          border
        ></Table>
        <Page
          :current="currentPage"
          :total="dataCount"
          :page-size="pageSize"
          show-sizer
          show-total
          @on-change="changePage"
          @on-page-size-change="changePageSize"
          style="text-align:right"
        ></Page>
      </TabPane>
      <TabPane label="树形结构" name="tree" icon="ios-git-merge">
        <Row span="24" :gutter="8">
          <Col span="3">
            <Button
              icon="md-cloud-download"
              type="primary"
              long
              @click="exportAddressTemplate"
            >导出地址模板</Button>
          </Col>
          <Col span="3">
            <Button
              type="primary"
              long
              icon="md-cloud-upload"
              onclick="$('#upload_file_address').click();"
            >按地址模板导入</Button>
          </Col>
          <Col span="2">
            <Button type="primary" long @click="openAll">全部展开</Button>
          </Col>
          <Col span="2">
            <Button type="primary" long @click="closeAll">全部收回</Button>
          </Col>
          <Col span="4">
            <Input
              v-model="searchString"
              placeholder="回车快速定位"
              @on-change="searchWords"
              style="margin-left:10px; width: 150px"
            />
          </Col>
          <!-- <Col span="3">
            <Button
              v-if="searchString != ''"
              type="primary"
             
              @click="enterNext"
            >下一个</Button>
          </Col>-->
          
          <!-- @keyup.enter.native="enterNext" -->
          <Upload
            ref="upload"
            name="upfile"
            action="/api/importAddressTemplate"
            :on-success="handleImportAddressTemplate"
            :format="['xlsx','xls']"
            :show-upload-list="false"
          >
            <input id="upload_file_address" style="display: none;" />
          </Upload>
        </Row>
        <Tree id="tree" :data="data5" :render="renderContent"></Tree>
      </TabPane>
    </Tabs>

    <!-- 模态框 -->
    <Modal title="Title" v-model="isModalShow" :mask-closable="false" width="380">
      <p slot="header" style="color:#0066FF;text-align:center">
        <Icon type="md-create" />
        <span>{{modalTitle}}</span>
      </p>
      <div style="text-align:center">
        <div style="margin-bottom: 10px">
          <span>父级地址名称</span>
          <Input readonly v-model="parentNodeName" style="margin-left:10px; width: 150px" />
        </div>
        <div style="margin-bottom: 10px">
          <span>父级地址编号</span>
          <Input readonly v-model="parentNodeId" style="margin-left:10px; width: 150px" />
        </div>
        <div style="margin-bottom: 10px">
          <span>当前地址名称</span>
          <Input
            v-model="currentNodeName"
            placeholder="请输入当前地址名称"
            style="margin-left:10px; width: 150px"
          />
        </div>
        <div style="margin-bottom: 10px">
          <span>当前地址编号</span>
          <Input readonly v-model="currentNodeId" style="margin-left:10px; width: 150px" />
        </div>
        <div style="margin-bottom: 10px">
          <span>当前地址类型</span>
          <Select
            v-model="currentNodeType"
            style="margin-left:10px; width:150px"
            placeholder="请选地址类型"
          >
            <Option v-for="(value, key) in addressTypeEnum" :value="value" :key="key">{{value}}</Option>
          </Select>
        </div>
        <div style="margin-bottom: 10px">
          <span>当前管辖机构</span>
          <Select
            v-model="currentGoverningBody"
            style="margin-left:10px; width:150px"
            placeholder="请选员工管辖机构"
          >
            <Option
              v-for="value in governingBodyList"
              :value="value.governingBodyId"
              :key="value.governingBodyId"
            >{{value.governingBodyName}}</Option>
          </Select>
        </div>
      </div>
      <div slot="footer">
        <Button
          :loading="isLoading"
          icon="md-search"
          type="info"
          size="large"
          long
          @click="modalButtonClick"
        >{{modalButtonName}}</Button>
      </div>
    </Modal>
    <!-- 模态框 -->
    <Modal v-model="isShowModalSearch" :mask-closable="false" width="380">
      <p slot="header" style="color:#2d8cf0;text-align:center">
        <Icon type="md-create" />
        <span>按照输入的字段检索地址</span>
      </p>
      <Form ref="searchParam" :label-width="100" :model="searchParam">
        <FormItem prop="addressLowestLevelAddressId" label="地址：">
          <Cascader
            :data="addressData"
            change-on-select
            filterable
            transfer
            @on-change="chooseAddress"
          ></Cascader>
        </FormItem>
        <FormItem prop="governingBodyName" label="管辖机构：">
          <Input v-model="searchParam.governingBodyName" clearable placeholder="请输入管辖机构..."></Input>
        </FormItem>
        <FormItem prop="governingBodyType" label="管辖机构类型：">
          <Input v-model="searchParam.governingBodyType" clearable placeholder="请输入管辖机构类型..."></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" size="large" long @click="commitSearch">检索</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "address_menu",
  computed: {
    divStyle() {
      var style = {};
      if (this.$parent.$refs.mainContent) {
        style.width = this.$parent.$refs.mainContent.clientWidth - 54 + "px";
      } else {
        style.width = window.innerWidth - 279 + "px";
      }
      //style.height = (this.$parent.$refs.mainContent.clientHeight - 54) + 'px';
      return style;
    }
  },
  // beforeCreate() {
  //     this.$Notice.info({
  //         title: "beforeCreate"
  //     });
  // },
  // created() {
  //     this.$Notice.info({
  //         title: "created"
  //     });
  // },
  // beforeMount(){
  //     this.$Notice.info({
  //         title: "beforeMount"
  //     });
  // },
  mounted() {
    // this.$Notice.info({
    //     title: "mounted"
    // });
    this.request();
    this.showPage();
    var that = this;
    $(function() {
      document.onkeydown = function(e) {
        if (that.$parent.currentPage == "address_menu") {
          var ev = document.all ? window.event : e;
          if (ev.keyCode == 13) {
            that.enterNext();
          }
        }
      };
    });
  },
  data() {
    return {
      isLoading: false,
      isShowModalSearch: false,
      searchString: "",
      lastWords: "",
      searchParam: {
        contrastAddressType: "户号"
      },
      addressData: [],
      currentPage: 1,
      dataCount: 0,
      pageSize: 10,
      showData: [],
      showColumns: [
        {
          title: "地址名称",
          key: "addressLowestLevelAddressIds"
          // ,
          // tooltip: true
        },
        {
          title: "管辖机构",
          key: "governingBodyName"
        },
        {
          title: "管辖机构类型",
          key: "governingBodyType"
        }
      ],
      height: window.innerHeight,
      isSpinShow: false,
      data5: [],
      isModalShow: false,
      modalButtonName: "新增",
      modalTitle: "新增地址",
      modalType: "add",
      parentNodeName: "",
      parentNodeId: 0,
      currentNodeName: "",
      currentNodeId: 0,
      currentNodeType: "",
      currentGoverningBody: "",
      currentInfoId: "",
      addressTypeEnum: global.addresstype,
      level: "",
      buttonProps: {
        type: "default",
        size: "small"
      },
      governingBodyList: [],
      addressUrl: "/api/downloadAddressTemplate",
      currentLabel: [],
      currentLabelIndex: 0
    };
  },
  methods: {
    enterNext() {
      console.log(this.currentLabel);
      console.log(this.currentLabelIndex);
      if (this.currentLabel && this.currentLabel.length != 0) {
        $(".main-content").animate(
          {
            scrollTop:
              this.currentLabel[this.currentLabelIndex].offsetTop + "px"
          },
          0
        );
        if (this.currentLabelIndex == this.currentLabel.length - 2) {
          this.currentLabelIndex = 0;
        } else {
          this.currentLabelIndex += 2;
        }
      }
    },
    searchWords() {
      this.openAll();
      if (this.lastWords != "") {
        $(
          ".ivu-tree-children span span:contains('" + this.lastWords + "')"
        ).css("background", "white");
      }

      if (this.searchString != "") {
        $(
          ".ivu-tree-children span span:contains('" + this.searchString + "')"
        ).css("background", "#FFCC66");
        this.currentLabel = $(
          ".ivu-tree-children span span:contains('" + this.searchString + "')"
        );
        //         container.scrollTop(
        //     scrollTo.offset().top - container.offset().top + container.scrollTop()
        // );
      }
      this.lastWords = this.searchString;
    },
    openAll() {
      this.openChildren(this.data5);
    },
    closeAll() {
      this.closeChildren(this.data5);
    },
    openChildren(array) {
      for (let i = 0; i < array.length; i++) {
        let temp = array[i];
        if (temp["children"] != undefined) {
          temp["expand"] = true;
          this.openChildren(temp["children"]);
        }
      }
    },
    closeChildren(array) {
      for (let i = 0; i < array.length; i++) {
        let temp = array[i];
        if (temp["children"] != undefined) {
          temp["expand"] = false;
          this.closeChildren(temp["children"]);
        }
      }
    },
    showPage() {
      let that = this;
      that.isSpinShow = true;
      $.ajax({
        url:
          "/api/getAddressList?page=" +
          that.currentPage +
          "&pageAmount=" +
          that.pageSize,
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(that.searchParam),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          that.showData = data.body.resultList;
          that.dataCount = data.body.amount;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.isSpinShow = false;
        }
      });
    },
    changePage(index) {
      this.currentPage = index;
      this.showPage();
    },
    changePageSize(size) {
      this.pageSize = size;
      this.showPage();
    },
    request() {
      var that = this;
      that.isSpinShow = true;
      $.ajax({
        url: "/api/getAddressTree",
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              /* */ desc: data.errorInfo
            });
            return;
          }
          that.addressData = data.body[0].children;

          data.body[0]["render"] = (h, { root, node, data }) => {
            return (
              "span",
              {
                style: {
                  display: "inline-block",
                  width: "100%"
                }
              },
              [
                h("span", [
                  h("Icon", {
                    props: {
                      type: "ios-folder-outline"
                    },
                    style: {
                      marginRight: "8px"
                    }
                  }),
                  h("span", data.title)
                ]),
                h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      marginLeft: "32px",
                      marginRight: "32px"
                    }
                  },
                  [
                    h("Button", {
                      props: Object.assign({}, that.buttonProps, {
                        icon: "ios-add",
                        type: "primary"
                      }),
                      style: {
                        width: "64px"
                      },
                      on: {
                        click: () => {
                          if (localStorage.getItem("isAdmin") == "false") {
                            that.isModalShow = false;
                            that.$Notice.info({
                              title: "提示",
                              desc: "您的权限不足！"
                            });
                            return;
                          } else {
                            that.append(root, node, data);
                          }
                        }
                      }
                    })
                  ]
                )
              ]
            );
          };
          that.data5 = data.body;
          console.log(that.data5);
          that.$Notice.success({
            title: "提示",
            desc: "载入地址信息成功"
          });
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          //that.isSpinShow = false;
        }
      });
      $.ajax({
        url: "/api/info/governingBodyList",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({}),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          that.governingBodyList = data.body;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    renderContent(h, { root, node, data }) {
      return h(
        "span",
        {
          style: {
            display: "inline-block",
            width: "100%"
          }
        },
        [
          h("span", [
            h("Icon", {
              props: {
                type: "ios-paper-outline"
              },
              style: {
                marginRight: "8px"
              }
            }),
            h("span", data.title)
          ]),
          h(
            "span",
            {
              style: {
                display: "inline-block",
                marginLeft: "32px",
                marginRight: "32px"
              }
            },
            [
              h("Button", {
                props: Object.assign({}, this.buttonProps, {
                  icon: "ios-add"
                }),
                style: {
                  marginRight: "8px"
                },
                on: {
                  click: () => {
                    this.append(root, node, data);
                  }
                }
              }),
              h("Button", {
                props: Object.assign({}, this.buttonProps, {
                  icon: "ios-remove"
                }),
                style: {
                  marginRight: "8px"
                },
                on: {
                  click: () => {
                    this.remove(root, node, data);
                  }
                }
              }),
              h("Button", {
                props: Object.assign({}, this.buttonProps, {
                  icon: "ios-create-outline"
                }),
                on: {
                  click: () => {
                    this.edit(root, node, data);
                  }
                }
              })
            ]
          )
        ]
      );
    },
    append(root, node, data) {
      console.log(root);
      console.log(node);
      console.log(data);
      (this.modalButtonName = "新增"),
        (this.modalTitle = "新增地址"),
        (this.modalType = "add"),
        (this.parentNodeName = node.node.title);
      this.currentNodeId = "";
      this.parentNodeId = data.id;
      this.isModalShow = true;
      this.currentGoverningBody = data.infoGoverning;
      this.currentInfoId = data.infoId;
      this.currentNodeName = "";
      this.currentNodeType = "";
      if (data.id == 0) {
        this.level = 0;
      } else {
        this.level = data.level;
      }
      const children = data.children || [];
      this.$set(data, "expand", true);
      this.$set(data, "children", children);
      this.isModalShow = true;
    },
    remove(root, node, data) {
      const parentKey = root.find(el => el === node).parent;
      const parent = root.find(el => el.nodeKey === parentKey).node;
      const index = parent.children.indexOf(data);
      this.delAddressInfo(data.id);
    },
    edit(root, node, data) {
      const parentKey = root.find(el => el === node).parent;
      const parent = root.find(el => el.nodeKey === parentKey).node;
      (this.modalButtonName = "修改"),
        (this.modalTitle = "修改地址"),
        (this.modalType = "edit"),
        (this.parentNodeName = parent.title);
      this.currentGoverningBody = data.infoGoverning;
      this.currentInfoId = data.infoId;
      this.level = data.level;
      this.parentNodeId = data.pid;
      this.currentNodeName = data.title;
      this.currentNodeId = data.id;
      this.currentNodeType = data.type;
      this.isModalShow = true;
    },
    delAddressInfo(id) {
      this.$Modal.confirm({
        title: "确认",
        content: "<p>确认删除当前节点及子节点信息？</p>",
        onOk: () => {
          var that = this;
          that.isSpinShow = true;
          $.ajax({
            url: "/api/delBaseAddress",
            contentType: "application/json",
            type: "post",
            data: JSON.stringify({
              id: id
            }),
            dataType: "json",
            success: function(data) {
              console.log(data);
              if (data.errorCode != 0) {
                that.$Notice.error({
                  title: "异常",
                  desc: data.errorInfo
                });
                return;
              }
              that.request();
              that.$Notice.success({
                title: "提示",
                desc: "地址基础信息删除成功"
              });
            },
            error: function(textStatus) {
              that.loading = false;
              that.$Notice.error({
                title: "异常",
                desc: "接口请求异常"
              });
            },
            complete: function() {
              that.isSpinShow = false;
            }
          });
        },
        onCancel: () => {}
      });
    },
    commitVerification() {
      if (!this.currentNodeName) {
        this.$Notice.warning({
          title: "异常",
          desc: "请输入地址名称！"
        });
        return false;
      }
      if (!this.currentNodeType) {
        this.$Notice.warning({
          title: "异常",
          desc: "请输入地址类型！"
        });
        return false;
      }
      if (!this.currentGoverningBody) {
        this.$Notice.warning({
          title: "异常",
          desc: "请输入管辖机构！"
        });
        return false;
      }
      return true;
    },
    modalButtonClick() {
      if (this.commitVerification()) {
        var that = this;
        that.isSpinShow = true;
        that.isLoading = true;
        that.isModalShow = false;
        $.ajax({
          url: "/api/updateBaseAddress",
          contentType: "application/json",
          type: "post",
          data: JSON.stringify({
            updateType: this.modalType,
            pid: this.parentNodeId,
            name: this.currentNodeName,
            type: this.currentNodeType,
            id: this.currentNodeId,
            level: this.level,
            infoGoverning: this.currentGoverningBody,
            infoId: this.currentInfoId
          }),
          dataType: "json",
          success: function(data) {
            console.log(data);
            if (data.errorCode != 0) {
              that.$Notice.error({
                title: "异常",
                desc: data.errorInfo
              });
              return;
            }
            that.request();
            that.isModalShow = false;
            that.$Notice.success({
              title: "提示",
              desc: "地址基础信息升级成功"
            });
          },
          error: function(textStatus) {
            that.loading = false;
            that.$Notice.error({
              title: "异常",
              desc: "]"
            });
          },
          complete: function() {
            that.isSpinShow = false;
            that.isLoading = false;
            that.currentNodeName = "";
            that.currentGoverningBody = "";
            that.currentNodeType = "";
          }
        });
      }
    },
    exportAddressTemplate() {
      window.location.href = this.addressUrl;
    },
    handleImportAddressTemplate(response, file, fileList) {
      console.log(response);
      console.log(file);
      console.log(fileList);
      this.handelResponse(response);
    },
    handelResponse(response) {
      if (response.errorCode != 0) {
        this.$Notice.error({
          title: "导入失败",
          desc: response.errorInfo,
          duration: 0
        });
      } else {
        let result = response.body.repeatArray;
        let insert = response.body.insertArray;
        let count = "\n共计导入" + insert.length + "条数据。";
        let indexs = "";
        if (result.length > 0) {
          result.map(item => {
            indexs =
              indexs == "" ? item.index + 2 : indexs + "," + (item.index + 2);
          });
        }
        let msg =
          indexs == ""
            ? ""
            : "\n第" + indexs + "行数据与数据库中数据重复,不予导入。";
        this.$Notice.success({
          title: "成功",
          desc: "导入成功！" + msg + count,
          duration: 0
        });
        this.request();
        this.showPage();
      }
    },
    handleError(error, file, fileList) {
      console.log(error);
      console.log(file);
      console.log(fileList);
      this.$Notice.error({
        title: "导入失败",
        desc: error,
        duration: 0
      });
    },
    onClickSearch() {
      this.isShowModalSearch = true;
    },
    commitSearch() {
      console.log(this.searchParam);
      this.isShowModalSearch = false;
      this.showPage();
    },
    chooseAddress(param) {
      console.log(param);
      if (param.length > 0) {
        this.searchParam.addressLowestLevelAddressId =
          param[param.length - 1] * 1; //当复选框选中时则会打印出选中的内容
      } else {
        this.searchParam.addressLowestLevelAddressId = null;
      }
    }
  }
};
</script>
<style>
.ivu-tree {
  left: 30%;
}

.ivu-tree ul {
  /* list-style: none; */
  margin: 5px;
  padding: 0;
  font-size: 16px;
}
</style>
